// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--jira-warepil/backlog-placement';

import { MessageFrontend as createMessageFrontendJiraBacklogAgentSetupBanner } from '@post-office/browser--jira-warepil/jira-backlog-agent-setup-banner/placements/in-app-v2/backlog-placement';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type PlacementRenderProps } from '@post-office/browser--jira-warepil/backlog-placement';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendJiraBacklogAgentSetupBanner({
		messageTemplateId: 'jira-backlog-agent-setup-banner',
	}),
];

export const RawPlacement: PlacementRendererStage<PlacementRenderProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<PlacementRenderProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<PlacementRenderProps> = RawPlacement;
